import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, callCostDetailFeatureKey } from './call-cost-detail.reducer';

export const callCostDetailFeature = createFeatureSelector<State>(callCostDetailFeatureKey);

export const getCallCost = createSelector(callCostDetailFeature, (state) => {
   return state.callCost;
});

export const getCallCostCallState = createSelector(callCostDetailFeature, (state) => {
   return state.callState;
});
